export const OrderViewType = {
  All: "all",
  My: "my",
  Storefront: "storefront",
  PendingApprovals: "pendingApprovals",
} as const;

export type OrderViewType = (typeof OrderViewType)[keyof typeof OrderViewType];

